import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from "react-router-dom";

import moment from "moment";
import download from "../../../Images/download.svg";

import { UrlPath } from "../../../config/routeConfig";

import { TopBar } from '../../shared/topBar/TopBar';
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";

import { getTaxEntityDetailAction, getTaxEntityListAction } from "../../actions/investorAccounts";
import { SBAComboBox } from "../../UiComponents/SBADropDown";
import { SBDatePicker } from "../../UiComponents/SBDatePicker";
import { sbaAxios } from "../../utils/sbaAxios";
import { getContactRM, getCurrencyInfo, getErisaAPI, getFormPFAPI, getNewIssueDSApi, getTaxEntityPortfoliosApi, getTaxEntityStatusDSApi, getTaxStatusDSApi, updateTaxEntityAPI } from "../../../config/apiConfig";
import { getContactList } from "../../../config/apiConfig";
import { SBNotify } from "../../utils/sbNotify";
import { ToastContainer } from "react-toastify";
import { getCommonCountries, getCommonState } from "../../actions/CommonAction";



export const InvestorAccountEdit = () => {
    const param = useParams();
    const dispatch = useDispatch();
    const history = useNavigate();
    const Gstate = useSelector(state => state);
    const taxEntityList = Gstate.investorAccounts.taxEntityList;
    const taxEntityDetails = Gstate.investorAccounts.taxEntityDetail;
    const istaxEntityDetailsLoading = Gstate.investorAccounts.isTaxEntityDetailLoading;
    const [detailedTaxEntity, setDetailedTaxEntity] = useState(taxEntityDetails);

    const Level = [{ BreadCrumb: "CRM >", Routes: `${UrlPath.Investor}` }, { BreadCrumb: `Accounts >`, Routes: `${UrlPath.InvestorAccounts}` }, { BreadCrumb: `${detailedTaxEntity?.TaxEntityName} >`, Routes: `${UrlPath.InvestorAccountDetails}${param.EntityID}` }];




    useEffect(() => {
        setDetailedTaxEntity(taxEntityDetails);
    }, [taxEntityDetails]);

    useEffect(() => {
        document.title = "Account Details"
        dispatch(getTaxEntityListAction());
        dispatch(getCommonState());
        dispatch(getCommonCountries())
        if (param.EntityID)
            dispatch(getTaxEntityDetailAction(param.EntityID));
    }, []);
    return (
        <>
            <TopBar label={"Account Details"} />
            <div className="mainContentData">
                <BreadCrumbs Levels={Level} />
                <div className="container-fluid">
                    <div className="bg-white p-3 border rounded">
                        {istaxEntityDetailsLoading ? <><LoadingScreen /></> :
                            <><AccountDetailsEdit details={detailedTaxEntity} /></>}
                    </div>
                </div>
            </div>
        </>
    )
};
export const AccountDetailsEdit = ({ details, addAccount }) => {
    const location = useLocation();
    const preActiveTab = location?.state?.ActiveTab || "General";


    const [accountDetail, setAccountDetail] = useState(details);

    const [activeTab, setActiveTab] = useState(preActiveTab);

    useEffect(() => {
        setAccountDetail(details);
    }, [details]);
    return <>
        <div class="header-container"><b>
            {activeTab}</b></div>
        {activeTab === 'General' && <><GeneralInfoEdit details={accountDetail} addAccount={addAccount} /></>}
        {activeTab === 'Register Address' && <><AddressesEdit details={accountDetail} /></>}
        {/* {activeTab === 'Others' && <><OthersEdit details={accountDetail} /></>} */}
        <ToastContainer/>
    </>
};
export const GeneralInfoEdit = ({ details, addAccount }) => {
    const history = useNavigate();
    const param = useParams();
    const [detail, setDetail] = useState(details);
    const [taxStatus, setTaxStatus] = useState(
        {
            "TaxStatusId": detail?.TaxStatusId,
            "TaxStatusName": detail?.TaxStatusName
        }
    );
    const [currency, setCurrency] = useState(
        {
            "currencyID": detail?.CurrencyID,
            "CurrencyName": detail?.CurrencyName
        }
    );
    const [erisa, setErisa] = useState(
        {
            "ErisaId": 0,
            "Erisa": "--Please Select--"
        }
    );
    const [Finra5130, setFinra5130] = useState(
        {
            "NewIssueId": 0,
            "NewIssueName": "--Please Select--"
        }
    );
    const [Finra5131, setFinra5131] = useState(
        {
            "NewIssueId": 0,
            "NewIssueName": "--Please Select--"
        }
    );
    const [formPF, setFormPF] = useState(
        {
            "FormPFId": 0,
            "FormPFName": "--Please Select--"
        }
    );
    const [taxEntityStatus, setTaxEntityStatus] = useState(
        {
            "TaxEntityStatusId": detail?.TaxEntityStatusId,
            "TaxEntityStatusName": detail?.TaxEntityStatusName
        }
    );
    const [taxEntityIssue, setTaxEntityIssue] = useState(
        {
            "NewIssueId": detail?.NewIssueId,
            "NewIssueName": detail?.NewIssueName
        }
    );
    const [contactItem,setContactItem]=useState({
        "ContactId":detail?.ContactId,
        "ContactName":detail?.ContactName
    }); 
    const [portfolioItem,setPortfolioItem]=useState({
        "PortfolioId":detail?.PortfolioId,
        "PortfolioName":detail?.PortfolioName
    });


    const [taxStatusDS, setTaxStatusDS] = useState([]);
    const [currencyDS, setCurrencyDS] = useState([]);
    const [taxEntityStatusDS, setTaxEntityStatusDS] = useState([]);
    const [newIssueDS, setNewIssueDS] = useState([]);
    const [erisaDS, setErisaDS] = useState([]);
    const [formPFDS, setFormPFDS] = useState([]);
    const [contactItemDs,setContactItemDs]=useState([]);
    const [portfolioItemDS,setPortfolioItemDS]=useState([]);

    const navigateBack = () => {
        addAccount ? history(`${UrlPath.InvestorAccounts}`) :
            history(`${UrlPath.InvestorAccountDetails}${param.EntityID}`);
    }
    useEffect(() => {
        getInitialDataSource(getTaxStatusDSApi, setTaxStatusDS);
        getInitialDataSource(getTaxEntityStatusDSApi, setTaxEntityStatusDS);
        getInitialDataSource(getNewIssueDSApi, setNewIssueDS);
        getInitialDataSource(getFormPFAPI, setFormPFDS);
        getInitialDataSource(getErisaAPI, setErisaDS);
        getInitialDataSource(getCurrencyInfo,setCurrencyDS)
    }, []);
    const getInitialDataSource = (api, setter) => {
        sbaAxios({ url: api }).then(res => {
            setter(res);
        }).catch(e => {
            setter([]);
            console.log(e, 'Error Fetching Data For Drop Down');
        })
    }
    useEffect(() => {
        setDetail(details);
        setTaxEntityIssue({
            "NewIssueId": details?.NewIssueId,
            "NewIssueName": details?.NewIssueName
        },);
        setTaxEntityStatus({
            "TaxEntityStatusId": details?.TaxEntityStatusId,
            "TaxEntityStatusName": details?.TaxEntityStatusName
        });
        setTaxStatus({
            "TaxStatusId": details?.TaxStatusId,
            "TaxStatusName": details.TaxStatusName
        });
        setFinra5130({
                "NewIssueId": details?.Finra5130,
            "NewIssueName": details?.Finra5130Name
        });
        setFinra5131({
            "NewIssueId": details?.Finra5131,
            "NewIssueName": details?.Finra5131Name
        });
        setErisa({
            "ErisaId": details?.ErisaId,
            "Erisa": details?.Erisa
        });
        setFormPF({
            "FormPF":details?.FormPF,
            "FormPFId":details?.FormPFId,
        })
        setContactItem({
            "ContactId":details?.ContactId,
            "ContactName":details?.ContactName
        });
        setCurrency({
            "currencyID": details?.CurrencyID,
            "CurrencyName": details?.CurrencyName
        });
        setPortfolioItem({
            "PortfolioId":details?.PortfolioId,
            "PortfolioName":details?.PortfolioName
        })
    }, [details]);
    const saveGeneralTab = () => {
        const updatedData = {
            "taxEntityId": detail?.TaxEntityId || 0,
            "taxEntityName": detail?.TaxEntityName || "",
            "portfolioId": detail?.PortfolioId || null,
            "contactId": detail?.ContactId || 0,
            "abbreviation": detail?.Abbreviation || "",
            "inactiveDate": detail?.InactiveDate || "",
            "taxEntityStatusId": detail?.TaxEntityStatusId || 0,
            "inceptionDate": detail?.InceptionDate || "",
            "taxId": detail?.TaxId || "",
            "currencyId": detail?.CurrencyId || 0,
            "taxStatusId": detail?.TaxStatusId || 0,
            "isSideLetter": detail?.IsSideLetter,
            "erisaId": detail?.ErisaId || 0,
            "erisaPercent": detail?.ErisaPercent,
            "newIssueId": detail?.NewIssueId,
            "cftc": detail?.CFTC || false,
            "isSidePocket": detail?.IsSidePocket || false,
            "isRestricted": detail?.IsRestricted || false,
            "finra5130": detail?.Finra5130 || 0,
            "finra5131": detail?.Finra5131 || 0,
            "formPFId": detail?.FormPFId || 0,
            "bankName": detail?.BankName || "",
            "wireInstitutionName": detail?.WireInstitutionName || "",
            "wireABANumber": detail?.WireABANumber || "",
            "wireNotes": detail?.WireNotes || "",
            "wireAccountNumber": detail?.WireAccountNumber || "",
            "wireBankInformation": detail?.WireBankInformation || "",
            "wireAdditionalInstructions": detail?.WireAdditionalInstructions || "",
            "stockDeliveryInstructions":detail?.StockDeliveryInstructions || "",
            "registeredAddress": detail?.RegisteredAddress || "",
            "registeredCity": detail?.RegisteredCity || "",
            "registeredState": detail?.RegisteredState || "",
            "registeredZip": detail?.RegisteredZip || "",
            "registeredProvince": detail?.RegisteredProvince || "",
            "registeredCountry": detail?.RegisteredCountry || "",
            "registeredCountryId": detail?.RegisteredCountryId||"",
            "notes": detail?.Notes || "",
            "modifiedBy": 0,
            "ContactTaxEntRoleXRefId": details.ContactTaxEntRoleXRefId || 0
        };
        if (updatedData.taxEntityName && updatedData.taxEntityStatusId && updatedData.contactId)
        {
            sbaAxios({
                url: updateTaxEntityAPI, data: updatedData, method: "post"
            }).then(res => {
                    history(`${UrlPath.InvestorAccountDetails}${res}`);
            }).catch(error => {
                console.log(error, 'error while updating the account tax entity ')
            });
        }
        else {
                    SBNotify({Msg:"Please Enter All the Mandatory Fields" ,type:"error"});
        }
      
    };
    const getMacthingContactList=(e)=>{
        const searchText=e.filter.value;
        sbaAxios({url:`${getContactRM}searchText=${searchText}&contactTypeId=1&onlyRM=true`}).then(result=>{
            setContactItemDs(result);
        }).catch(error=>{
            console.log("error Fetching Data for contact list",error);;
        });
    }
    const updateGeneralStateInfo = (newvalue, key) => {
        setDetail(value => ({ ...value, [key]: newvalue }));
    };
    const setAvailablePortfolio=(e)=>{ 
        const filterrtext=e.filter.value;
        if(filterrtext.length>1)
        {
            sbaAxios({url:`${getTaxEntityPortfoliosApi}?searchText=${filterrtext}`}).then(res=>{
                setPortfolioItemDS(res);
            }).catch(error=>{
                console.log(error +" Error Loading the Portfolio List");
            })
        }
    }
    return <>
        <div className="p-3">
            <div className="border-bottom my-2">
                <p className="fw-medium"> Account Information </p>
                <div className="row m-0 my-3">
                    <TextBoxEditor label={"Entity Name"} value={detail?.TaxEntityName} updateState={(newValue) => { updateGeneralStateInfo(newValue, "TaxEntityName") }} colSize={"col-md-3"} mandatory={true}/>
                    <TextBoxEditor label={"Abbreviation"} value={detail?.Abbreviation} updateState={(newValue) => { updateGeneralStateInfo(newValue, "Abbreviation") }} colSize={"col-md-3"} />
                    <DropDownEditor label={"Status"} value={taxEntityStatus} data={taxEntityStatusDS} textField={"TaxEntityStatusName"} valueField={"TaxEntityStatusId"} updateState={(newValue) => {
                        setDetail((value) => ({ ...value, TaxEntityStatusName: newValue?.TaxEntityStatusName, TaxEntityStatusId: newValue?.TaxEntityStatusId }));
                        setTaxEntityStatus(newValue)
                    }} colSize={"col-md-3"} mandatory={true} />
                    <DatePickerEditor label={"Inception Date"} value={detail?.InceptionDate} updateState={(newValue) => { updateGeneralStateInfo(newValue, "InceptionDate") }} colSize={"col-md-3"} />
                </div>
                <div className="row m-0 my-3">
                    <DropDownEditor label={"Relationship Master"} value={contactItem} data={contactItemDs} textField={"ContactName"} valueField={"ContactId"} updateState={(newValue) => {
                        setDetail((pvalue) => ({ ...pvalue, ContactId: newValue.ContactId, ContactName: newValue.ContactName }));
                        setContactItem(newValue)
                    }} colSize={"col-md-3"} onFilterChange={getMacthingContactList} mandatory={true} placeholder={"Please Enter"}/>
                    <TextBoxEditor label={"TaxID"} value={detail?.TaxId} updateState={(newValue) => { updateGeneralStateInfo(newValue, "TaxId") }} colSize={"col-md-3"}/>
                    <DropDownEditor label={"Linked Portfolio"} value={portfolioItem} data={portfolioItemDS} textField={"PortfolioName"} valueField={"PortfolioId"} updateState={(newValue) => {
                        setDetail((pvalue) => ({ ...pvalue, PortfolioId: newValue?.PortfolioId, PortfolioName: newValue?.PortfolioName }));
                        setPortfolioItem(newValue)
                    }} colSize={"col-md-3"} placeholder={"Please Enter Portfolio Name "} 
                    onFilterChange={(e)=>{setAvailablePortfolio(e)}}
                />
                    <TextAreaEditor label={"Notes"} value={detail?.Notes} updateState={(newValue) => { updateGeneralStateInfo(newValue, "Notes") }} colSize={"col-md-3"} />
                </div>
            </div>
            <div className="border-bottom my-3">
                <p className="fw-medium"> Legal Information </p>
                <div className="row m-0 my-2">
                    <DropDownEditor label={"Currency"} value={currency} data={currencyDS} textField={"CurrencyName"} valueField={"CurrencyId"} updateState={(newValue) => {
                        setDetail((pvalue) => ({ ...pvalue, CurrencyName: newValue?.CurrencyName, CurrencyId: newValue?.CurrencyId }));
                        setCurrency(newValue)
                    }} colSize={"col-md-3"} />
                     <DropDownEditor label={"Tax Status"} value={taxStatus} data={taxStatusDS} textField={"TaxStatusName"} valueField={"TaxStatusId"} updateState={(newValue) => {
                        setDetail((pvalue) => ({ ...pvalue, TaxStatusName: newValue?.TaxStatusName, TaxStatusId: newValue?.TaxStatusId }));
                        setTaxStatus(newValue)
                    }} colSize={"col-md-3"} />
                    <DropDownEditor label={"Erisa"} value={erisa} data={erisaDS} textField={"Erisa"} valueField={"ErisaId"} updateState={(newValue) => {
                        setDetail((value) => ({ ...value, Erisa: newValue?.Erisa, ErisaId: newValue?.ErisaId }));
                        setErisa(newValue)
                    }} colSize={"col-md-3"} />
                    <TextBoxEditor label={"Erisa Percentage (%)"} value={detail?.ErisaPercent} updateState={(newValue) => { updateGeneralStateInfo(newValue, "ErisaPercent") }} colSize={"col-md-3"} />
                </div>
                <div className="row m-0 my-3">
                    <DropDownEditor label={"Finra 5130"} value={Finra5130} data={newIssueDS} textField={"NewIssueName"} valueField={"NewIssueId"} updateState={(newValue) => {
                        setDetail((value) => ({ ...value, Finra5130Name: newValue?.NewIssueName, Finra5130: newValue?.NewIssueId }));
                        setFinra5130(newValue)
                    }} colSize={"col-md-3"} />
                      <DropDownEditor label={"Finra 5131"} value={Finra5131} data={newIssueDS} textField={"NewIssueName"} valueField={"NewIssueId"} updateState={(newValue) => {
                        setDetail((value) => ({ ...value, Finra5131Name: newValue?.NewIssueName, Finra5131: newValue?.NewIssueId }));
                        setFinra5131(newValue)
                    }} colSize={"col-md-3"} />
                    {/* <NumberBoxEditor label={"Finra5130"} value={detail?.Finra5130} updateState={(newValue) => { setDetail({ ...detail, Finra5130: newValue }) }} colSize={"col-md-3"} /> */}
                    {/* <NumberBoxEditor label={"Finra5131"} value={detail?.Finra5131} updateState={(newValue) => { setDetail({ ...detail, Finra5131: newValue }) }} colSize={"col-md-3"} /> */}
                    <DropDownEditor label={"Form PF"} value={formPF} data={formPFDS} textField={"FormPF"} valueField={"FormPFId"} updateState={(newValue) => {
                        setDetail((value) => ({ ...value, FormPFName: newValue?.FormPFName, FormPFId: newValue?.FormPFId }));
                        setFormPF(newValue)
                    }} colSize={"col-md-3"} />
                      <DropDownEditor label={"New issue"} value={taxEntityIssue} data={newIssueDS} textField={"NewIssueName"} valueField={"NewIssueId"} updateState={(newValue) => {
                        setDetail((value) => ({ ...value, NewIssueId: newValue?.NewIssueId, NewIssueName: newValue?.NewIssueName }));
                        setTaxEntityIssue(newValue)
                    }} colSize={"col-md-3"} />
                    {/* <TextBoxEditor label={"FormPF"} value={detail?.FormPFId} updateState={(newValue) => { setDetail({ ...detail, FormPFId: newValue }) }} colSize={"col-md-3"} /> */}
                </div>
                <div className="row m-0 my-3">
                    <CheckBoxEditor label={"Side Letter"} value={detail?.IsSideLetter} updateState={(newValue) => { updateGeneralStateInfo(newValue, "IsSideLetter") }} colSize={"col-md-3"} />
                    <CheckBoxEditor label={"CTFC"} value={detail?.CFTC} updateState={(newValue) => { updateGeneralStateInfo(newValue, "CFTC") }} colSize={"col-md-3"} />
                    <CheckBoxEditor label={"Side Pocket"} value={detail?.IsSidePocket} updateState={(newValue) => { updateGeneralStateInfo(newValue, "IsSidePocket") }} colSize={"col-md-3"} />
                    <CheckBoxEditor label={"Restricted"} value={detail?.IsRestricted} updateState={(newValue) => { updateGeneralStateInfo(newValue, "IsRestricted") }} colSize={"col-md-3"} />
                </div>
            </div>

            <div className="border-bottom my-3">
                <p className="fw-medium"> Wire Information </p>
                <div className="row m-0 my-3">
                    <TextBoxEditor label={"Wire Instruction Name"} value={detail?.WireInstitutionName} updateState={(newValue) => { updateGeneralStateInfo(newValue, "WireInstitutionName") }} colSize={"col-md-3"} />
                    <TextBoxEditor label={"Bank Name"} value={detail?.BankName} updateState={(newValue) => { updateGeneralStateInfo(newValue, "BankName") }} colSize={"col-md-3"} />
                    <TextAreaEditor label={"Wire Bank Information"} value={detail?.WireBankInformation} updateState={(newValue) => { updateGeneralStateInfo(newValue, "WireBankInformation") }} colSize={"col-md-3"} />
                    <TextAreaEditor label={"Stock Delivery Instructions"} value={detail?.StockDeliveryInstructions} updateState={(newValue) => { updateGeneralStateInfo(newValue, "StockDeliveryInstructions") }} colSize={"col-md-3"} />
                    
                </div>
                <div className="row m-0 my-3">
                    <TextBoxEditor label={"Wire ABA"} value={detail?.WireABANumber} updateState={(newValue) => { updateGeneralStateInfo(newValue, "WireABANumber") }} colSize={"col-md-3"} />
                    <TextBoxEditor label={"Wire Account Number"} value={detail?.WireAccountNumber} updateState={(newValue) => { updateGeneralStateInfo(newValue, "WireAccountNumber") }} colSize={"col-md-3"} />
                    <TextAreaEditor label={"Wire Additional Instructions"} value={detail?.WireAdditionalInstructions} updateState={(newValue) => { updateGeneralStateInfo(newValue, "WireAdditionalInstructions") }} colSize={"col-md-3"} />
                    <TextAreaEditor label={"Wire Notes"} value={detail?.WireNotes} updateState={(newValue) => { updateGeneralStateInfo(newValue, "WireNotes") }} colSize={"col-md-3"} />
                </div>
            </div>
        </div>
        <div className="m-3 d-flex justify-content-end" ><button className="s-sm-btn" onClick={() => { navigateBack() }}>Cancel</button><button className="ms-2 p-sm-btn" onClick={saveGeneralTab}>{addAccount? "Save" :"Update"} </button></div>
    </>
};
export const AddressesEdit = ({ details }) => {
    const GState=useSelector(state=>state);

    const countryDS=GState.common.country;
    const stateDS=GState.common.state;
    const history = useNavigate();
    const param = useParams();
    const [detail, setDetail] = useState(details);
    const [state,setState]=useState(stateDS.find(item=>item.StateName===details?.RegisteredState));
    const [country,setCountry]=useState(countryDS.find(item=>item.CountryName===details?.RegisteredCountry));


    

    useEffect(() => {
        setDetail(details);
        setCountry(countryDS.find(item=>item.CountryName===details?.RegisteredCountry));
        setState(stateDS.find(item=>item.StateName===details?.RegisteredState));
    }, [details]);
    const updateGeneralStateInfo = (newvalue, key) => {
        setDetail(value => ({ ...value, [key]: newvalue }));
    };
    const saveAddressTab = () => {
        const updatedData = {
            "taxEntityId": detail?.TaxEntityId || 0,
            "taxEntityName": detail?.TaxEntityName || "",
            "portfolioId": detail?.PortfolioId || null,
            "contactId": detail?.ContactId || 0,
            "abbreviation": detail?.Abbreviation || "",
            "inactiveDate": detail?.InactiveDate || new Date().toISOString(),
            "taxEntityStatusId": detail?.TaxEntityStatusId || 0,
            "inceptionDate": detail?.InceptionDate || new Date().toISOString(),
            "taxId": detail?.TaxId,
            "currencyId": detail?.CurrencyId,
            "taxStatusId": detail?.TaxStatusId,
            "isSideLetter": detail?.IsSideLetter,
            "erisaId": detail?.ErisaId,
            "erisaPercent": detail?.ErisaPercent,
            "newIssueId": detail?.NewIssueId,
            "cftc": detail?.CFTC || false,
            "isSidePocket": detail?.IsSidePocket || false,
            "isRestricted": detail?.IsRestricted || false,
            "finra5130": detail?.Finra5130 || 0,
            "finra5131": detail?.Finra5131 || 0,
            "formPFId": detail?.FormPFId || 0,
            "bankName": detail?.BankName || "",
            "wireInstitutionName": detail?.WireInstitutionName || "",
            "wireABANumber": detail?.WireABANumber || "",
            "wireAccountNumber": detail?.WireAccountNumber || "",
            "wireNotes": detail?.WireNotes || "",
            "wireBankInformation": detail?.WireBankInformation || "",
            "wireAdditionalInstructions": detail?.WireAdditionalInstructions || "",
            "stockDeliveryInstructions":detail?.StockDeliveryInstructions || "",
            "registeredAddress": detail?.RegisteredAddress || "",
            "registeredCity": detail?.RegisteredCity || "",
            "registeredState": detail?.RegisteredState || "",
            "registeredZip": detail?.RegisteredZip || "",
            "registeredProvince": detail?.RegisteredProvince || "",
            "registeredCountry": detail?.RegisteredCountry || "",
            "registeredCountryId": detail?.RegisteredCountryId,
            "notes": detail?.Notes || "",
            "modifiedBy": 0
        };
        sbaAxios({
            url: updateTaxEntityAPI, data: updatedData, method: "post"
        }).then(res => {
            history(`${UrlPath.InvestorAccountDetails}${param.EntityID}` ,{ state: { ActiveTab: "Register Address" } });
        }).catch(error => {
            console.log(error, 'error while updating the account tax entity ')
        });
    };
    return <>
        <div className="p-2">
            <div className="my-3">
                <p className="fw-medium"> Address Information</p>
                <div className="row m-0 my-3">
                    <TextBoxEditor label={"Address"} value={detail?.RegisteredAddress} updateState={(newValue) => { updateGeneralStateInfo(newValue, 'RegisteredAddress') }} colSize={"col-md-3"} />
                    <TextBoxEditor label={"City"} value={detail?.RegisteredCity} updateState={(newValue) => { updateGeneralStateInfo(newValue, 'RegisteredCity') }} colSize={"col-md-3"} />
                    <DropDownEditor data={stateDS} label={"State"} textField={"StateName"} valueField={"StateId"} value={state} updateState={(newValue) => {setState(newValue); updateGeneralStateInfo(newValue?.StateName, 'RegisteredState') }} colSize={"col-md-3"} />
                    <TextBoxEditor label={"Zip"} value={detail?.RegisteredZip} updateState={(newValue) => { updateGeneralStateInfo(newValue, 'RegisteredZip') }} colSize={"col-md-3"} />
                </div>
                <div className="row m-0 my-3">
                    <TextBoxEditor label={"Province"} value={detail?.RegisteredProvince} updateState={(newValue) => { updateGeneralStateInfo(newValue, 'RegisteredProvince') }} colSize={"col-md-3"} />
                    <DropDownEditor data={countryDS} label={"Country"} textField={"CountryName"}
                    valueField={"CountryId"} value={country} updateState={(newValue) => { setCountry(newValue); setDetail(detail => ({ ...detail, RegisteredCountryName: newValue?.CountryName, RegisteredCountryId: newValue?.CountryId })) }} colSize={"col-md-3"} />

                </div>
            </div>
        </div>
        <div className="m-3 d-flex justify-content-end" ><button className="s-sm-btn" onClick={() => { history(`${UrlPath.InvestorAccountDetails}${param.EntityID}`, { state: { ActiveTab: "Register Address" } }) }}>Cancel</button><button className="ms-2 p-sm-btn" onClick={saveAddressTab}>Update</button></div>
    </>
};
export const OthersEdit = ({ details }) => {
    return <>
        <div className="detail p-2">
            Others
        </div>
    </>
};
export const TextBoxEditor = ({ label, value, colSize, updateState , mandatory }) => {
    return <div className={colSize}>
        <span className="fw-medium">{label} {mandatory && <span class="mandatory">*</span>}</span>
        <input className="form-control w-75" type="text" value={value || null} onChange={(e) => {
            const value = e.target.value || null
            updateState(value);
        }}></input>
    </div>
};
export const TextAreaEditor = ({ label, value, colSize, updateState }) => {
    const [text, setText] = useState(value);
    useEffect(() => { setText(value) }, [value])
    return <div className={colSize}>
        <span className="fw-medium">{label}</span>
        <textarea className="form-control" style={{ height: "150px", maxWidth: "400px" }} onChange={(e) => {
            const value = e.target.value;
            updateState(value);
        }}
            value={text}
        ></textarea>
    </div>
};
export const DatePickerEditor = ({ label, value, colSize, updateState }) => {
    return <div className={colSize}>
        <span className="fw-medium">{label}</span>
        <p>
            <SBDatePicker
                className="form-control w-75"
                value={value ? moment(value) : null}
                onChange={(newValue) => { updateState(newValue ?  newValue?.toISOString() : "") }
                }
            ></SBDatePicker>
        </p>
    </div>
};
export const DropDownEditor = (props) => {
    const { label, value, colSize, updateState, data, textField, valueField ,mandatory,...rest } = props;
    return <div className={colSize}>
        <span className="fw-medium">{label} {mandatory && <span class="mandatory">*</span>}</span>
        <p>
            <SBAComboBox className="w-75" value={value} data={data} onChange={(e) => {
                if (mandatory) {
                    if (e.value) { updateState(e.value) }
                } else updateState(e?.value) }} textField={textField} valueField={valueField} {...rest} />
        </p>
    </div>
};
export const CheckBoxEditor = (props) => {
    const { label, value, colSize, updateState } = props;
    return <div className={colSize}>
        <span className="fw-medium">{label}</span>
        <p>
            <input type="checkbox" checked={value || false} onChange={(e) => {
                const value = e.target.checked || false;
                updateState(value);
            }}></input>
        </p>

    </div>
};
export const NumberBoxEditor = ({ label, value, colSize, updateState }) => {
    return <div className={colSize}>
        <span className="fw-medium">{label}</span>
        <input className="form-control w-75" type="number" value={value || null} onChange={(e) => {
            const value = e.target.value || null
            updateState(value);
        }}></input>
    </div>
};
